export default __webpack_public_path__ + "static/media/M01.fa3a75a8.svg";